import { FC } from "react";
import {
  ATTRIBUTE_GROUP_STYLES,
  DETAILS_SECTION_STYLES,
  GROUP_STYLES,
  SUB_HEADER_STYLES,
} from "../styles";

const setStyles = (isNew?: boolean) =>
  isNew
    ? {
        attributesStyles: DETAILS_SECTION_STYLES,
        headerStyles: SUB_HEADER_STYLES,
        groupStyles: `${GROUP_STYLES} ${ATTRIBUTE_GROUP_STYLES} p-4`,
      }
    : {
        attributesStyles: "",
        headerStyles:
          "text-left text-xs uppercase tracking-[0.12em] text-stone-500 mb-4",
        groupStyles: ATTRIBUTE_GROUP_STYLES,
      };

type SwitchableGroupProps = {
  title?: string;
  isNewPage?: boolean;
};
export const SwitchableGroup: FC<
  React.PropsWithChildren<SwitchableGroupProps>
> = ({ title, isNewPage, children }) => {
  const { attributesStyles, headerStyles, groupStyles } = setStyles(isNewPage);
  return (
    <div className={attributesStyles}>
      {title && <h3 className={headerStyles}>{title}</h3>}
      <div className={groupStyles}>{children}</div>
    </div>
  );
};
